/**
 * Helper function to determine if two addresses are equal (case-insensitive comparison)
 * @param address1 First address
 * @param address2 Second address
 * @returns True if addresses are equal, false otherwise
 */
export function areEqualAddresses(address1: string | undefined, address2: string | undefined): boolean {
  if (!address1 || !address2) return false
  return address1.toLowerCase() === address2.toLowerCase()
}
